import numberFormatter from './numberFormatter';
import { COUNTRY_CODES } from '../constants/enums';

export const PROMISE_FIELDS = Object.freeze({
    SOV: 'sov',
    IDS_VAC: 'idsvac',
    PLAYS: 'plays',
    VAC: 'vac',
    CLASSIC_VAC: 'classicvac',
    CLASSIC_PANELS: 'classicpanels'
});

const FIELD_DISPLAY_CONFIG = {
    [PROMISE_FIELDS.SOV]: { suffix: '%', isPercent: true },
    [PROMISE_FIELDS.IDS_VAC]: { suffix: ' VAC', isPercent: false },
    [PROMISE_FIELDS.PLAYS]: { suffix: ' Plays', isPercent: false },
    [PROMISE_FIELDS.VAC]: { suffix: ' VAC', isPercent: false },
    [PROMISE_FIELDS.CLASSIC_VAC]: { suffix: ' EA-VAC', isPercent: false },
    [PROMISE_FIELDS.CLASSIC_PANELS]: { suffix: ' Panels', isPercent: false }
};

const COUNTRY_SUFFIX_OVERRIDES = {
    [COUNTRY_CODES.SWEDEN]: {
        [PROMISE_FIELDS.VAC]: ' EA-VAC'
    },
    [COUNTRY_CODES.NORWAY]: {
        [PROMISE_FIELDS.VAC]: ' VAC/VI',
        [PROMISE_FIELDS.CLASSIC_VAC]: ' VAC/VI'
    }
};

const getDisplayConfig = (targetField, countryCode) => {
    const field = targetField?.toLowerCase();
    const base = FIELD_DISPLAY_CONFIG[field];
    if (!base) return { suffix: '', isPercent: false };

    const countryOverrides = COUNTRY_SUFFIX_OVERRIDES[countryCode];
    const suffix = countryOverrides?.[field] ?? base.suffix;

    return { suffix, isPercent: base.isPercent };
};

const FIELD_RESOLVERS = {
    [PROMISE_FIELDS.SOV]: {
        getTarget: (orderLine) => orderLine.targetSoV ?? 0.0,
        getDelivered: (campaignInfo) => campaignInfo.soV ?? 0.0
    },
    [PROMISE_FIELDS.IDS_VAC]: {
        getTarget: (orderLine, idsTarget) => idsTarget ?? 0,
        getDelivered: (campaignInfo) => campaignInfo.idsVac ?? 0
    },
    [PROMISE_FIELDS.PLAYS]: {
        getTarget: (orderLine) => numberFormatter.roundContactsAsInPopAPI(orderLine.targetPlays ?? 0),
        getDelivered: (campaignInfo) => campaignInfo.plays ?? 0
    },
    [PROMISE_FIELDS.VAC]: {
        getTarget: (orderLine) => orderLine.targetVAC ?? 0,
        getDelivered: (campaignInfo) => campaignInfo.vacContacts ?? 0
    },
    [PROMISE_FIELDS.CLASSIC_VAC]: {
        getTarget: (orderLine) => orderLine.postingTargetVac ?? 0,
        getDelivered: (campaignInfo) => campaignInfo.podPostingsSuccessfulVAC ?? 0
    },
    [PROMISE_FIELDS.CLASSIC_PANELS]: {
        getTarget: (orderLine) => orderLine.postingTarget ?? 0,
        getDelivered: (campaignInfo) => campaignInfo.podPanelsDelivered ?? 0
    }
};

export const resolvePromiseValues = (promiseConfig, orderLine, campaignInfo, idsTarget = 0, countryCode = null) => {
    if (!promiseConfig) return { 
        target: 0, 
        delivered: 0, 
        suffix: '', 
        isPercent: false, 
        scaleTargetByWeeks: false, 
        classicNonMomsAllOrNothing: false };

    const { targetField, deliveredField, scaleTargetByWeeks, classicNonMomsAllOrNothing } = promiseConfig;
    const { suffix, isPercent } = getDisplayConfig(targetField || deliveredField, countryCode);

    const targetResolver = targetField ? FIELD_RESOLVERS[targetField.toLowerCase()] : null;
    const deliveredResolver = deliveredField ? FIELD_RESOLVERS[deliveredField.toLowerCase()] : null;

    const target = targetResolver ? targetResolver.getTarget(orderLine, idsTarget) : 0;
    const delivered = deliveredResolver ? deliveredResolver.getDelivered(campaignInfo) : 0;

    return { target, delivered, suffix, isPercent, 
        scaleTargetByWeeks: scaleTargetByWeeks || false, 
        classicNonMomsAllOrNothing: classicNonMomsAllOrNothing || false };
};
